/* eslint-disable no-param-reassign */
/* eslint-disable comma-dangle */
/* eslint-disable indent */
/* eslint-disable quotes */
/* eslint-disable quote-props */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';
import PropTypes from 'prop-types';
import flatten from 'lodash/flatten';
import get from 'lodash/get';
import find from 'lodash/find';
import values from 'lodash/values';
import uniq from 'lodash/uniq';
import uniqueId from 'lodash/uniqueId';
import reverse from 'lodash/reverse';
import HistoryItem from './HistoryItem';
import History from './History';
import HistoryTopFilter from './HistoryFilter';
import HistoryTopFilterTitle from './HistoryFilterTitle';
import {
  fetchAccountTransactions,
  fetchAccountCashTransactions,
  fetchOfferings,
  fetchAccountOrders,
  resetHistoryFilter,
  cancelTransfer,
} from '../../actions';
import { addNotification } from '../../actions/notifications';
import {
  fetchOfferingSubscriptions,
} from '../../actions/offeringSubscriptions';
import {
  fetchOfferingOrders,
  cancelOrder as cancelOfferOrder,
} from '../../actions/investment';
import {
  cancelOrder,
} from '../../actions/orders';
import {
  DEFAULT_CODE,
  cashTransactionTypes,
  cashTransactionStatuses,
  folioLookup,
  orderSubTypes,
  expirationTerms,
  securityOrderStates,
} from '../Folio/lookups';
import {
  transactionTypes,
  historyTransactionByCategories,
  filterTypeOptsByTransactionTypes,
} from './lookups';
import { formatQuantity } from '../SecurityDetail/SecurityDetail';

import loadGif from '../../assets/images/loading.gif';
import './styles.css';

const ALL_TRNS = 'All Transactions';
const defTypeOpts = [ALL_TRNS];
let shownCount = 0; // Count the number of history items displayed after filters

const getTransactionTypeForAccountTransactions = (categoryName) => {
  const mapping = find(historyTransactionByCategories, item => item.category === categoryName);
  return mapping ? mapping.type : transactionTypes.OTHERS;
};

export const getHistoryItemsFromAccntTrns = transactions => (
  // Filter out Electronic Funds Transfer transactions.  They are
  // duplicates of ACH Withdrawals and ACH Deposits returned by
  //  account cash transactions
  transactions.filter(trn => (
    get(trn, 'transactionType', '') !== 'Electronic Funds Transfer'
  )).map((trn) => {
    const symbolName = get(trn, 'symbolName', '');
    const categoryName = get(trn, 'categoryName', '');
    const description = symbolName === 'CASH' || symbolName === 'FDIC SWEEP NOT COVERED BY SIPC' ?
      '' : symbolName;
    const amount = categoryName === 'Internal Transfers' ?
      Number(get(trn, 'marketNet', 0)) : Number(get(trn, 'net', 0));
    const transactionType = getTransactionTypeForAccountTransactions(categoryName);
    const transactionCode = get(trn, 'transactionCode', '');
    const pending = false;
    const completed = find(['Trades', 'Deposits'], item => item === categoryName) !== undefined;
    let name = get(trn, 'transactionDesc');
    const type = get(trn, 'transactionType');
    if ((type === 'Wire' || type === 'Check') && name === 'Client Deposits') {
      name = `${type} Deposit`;
    }
    return ({
      key: uniqueId(),
      name,
      description,
      notes: get(trn, 'notes', ''),
      amount: transactionCode === 'B' ? -amount : amount,
      displayDate: Moment(get(trn, 'date')).format('MMM D, YYYY'),
      date: get(trn, 'date'),
      pending,
      completed,
      details: null,
      transactionType,
    });
  }));

export const getHistoryItemsFromOrders = (orders, subscriptions, offerOrders) => (
  flatten(orders.filter((order) => {
      /**
       * Clear out orders that are already displayed from order subscription entries
       * Folio returns subscribed and executed orders here but this causes duplication with getHistoryItemsFromOfferOrders
       */
      let doesOrderExist = false;
      const filteredOrderSubscriptions = subscriptions.filter(item => item.folioOrderOid === order.folioOrderOid);
      if (filteredOrderSubscriptions.length) {
        const filteredOfferOrders = offerOrders.filter(item =>
          item.folioPrivatePlacementOrderOid === filteredOrderSubscriptions[0].privatePlacementOrderOid);
        doesOrderExist = filteredOfferOrders.length >= 1;
      }
      return !doesOrderExist;
    }).map((order) => {
    const securityOrders = get(order, 'securityOrders', []);
    return (securityOrders.map((sec) => {
      const statusCode = folioLookup(securityOrderStates, get(sec, 'state', '')).code;
      const orderSide = get(sec, 'side', '0') === '1' ? 'Buy' : 'Sell';
      const amount = Number(get(sec, 'requestedDollarAmount', 0));
      const serviceFee = Number(get(order, 'totalFee'));
      const term = get(order, 'term', '');
      const orderType = folioLookup(orderSubTypes, get(order, 'orderSubType', ''));
      const cancellationRestricted = statusCode !== 'I';
      return {
        key: uniqueId(),
        name: `Security Order (${orderSide})`,
        description: get(sec, 'security.ticker', ''),
        notes: '',
        amount: orderSide === 'Buy' ? -(amount + serviceFee) : (amount - serviceFee),
        displayDate: Moment(get(order, 'creationDate')).format('MMM D, YYYY'),
        date: get(order, 'creationDate'),
        pending: statusCode === 'I' || statusCode === 'S',
        completed: statusCode === 'F' || statusCode === 'G',
        canceled: statusCode === 'C' || statusCode === '2' || statusCode === '3' || statusCode === '4',
        cancellationRestricted,
        type: 'offerOrder',
        transactionType: transactionTypes.SECURITY_TRADE,
        oid: get(order, 'folioOrderOid'),
        details: {
          transactionType: `Security ${orderSide} Order`,
          orderType: orderType.code !== DEFAULT_CODE ? orderType.display : null,
          sharesQuantity: Number(get(sec, 'requestedShareAmount')),
          limitPrice: Number(get(sec, 'limitPrice')),
          stopPrice: Number(get(sec, 'stopPrice')),
          netTotal: amount,
          serviceFee,
          expirationTerm: term ? folioLookup(expirationTerms, term).display : null,
        },
      };
    }));
  })));

export const getHistoryItemsFromCashTrns = transactions => (
  transactions.map((trn) => {
    const statusCode = folioLookup(cashTransactionStatuses, get(trn, 'status', '')).code;
    const statusDisplay = folioLookup(cashTransactionStatuses, get(trn, 'status', '')).display;
    const date = get(trn, 'createDateTime');
    let amount = Number(get(trn, 'amount', 0));
    const name = folioLookup(cashTransactionTypes, get(trn, 'transactionType', '')).display;
    if (name.endsWith('Withdrawal')) {
      amount = -amount;
    }
    const item = {
      key: uniqueId(),
      name,
      description: '',
      notes: `${get(trn, 'sourceDescription', '')} to ${get(trn, 'targetDescription', '')}`,
      amount,
      displayDate: Moment(date).format('MMM D, YYYY'),
      date,
      pending: statusCode === 'PD',
      completed: statusCode === 'CL' || statusCode === 'PR' || statusCode === 'RJ',
      canceled: statusCode === 'CC',
      type: 'cashTransaction',
      oid: get(trn, 'oid'),
      transactionType: transactionTypes.MONEY_TRANSACTION,
      details: {
        date: Moment(date).format('MMM D, YYYY'),
        amount,
        status: statusDisplay,
        transactionType: name,
        source: trn.sourceDescription,
        target: trn.targetDescription,
      },
    };
    return item;
  }));


const PendingOrderNote = (
  <span>
    A pending order is an order that was not yet executed. Your pending
    order will be completed once confirmed and verified by My IPO and your
    shares have been issued.
    <br />
    <br />
    Your order will remain pending until the investment is accepted on the
    closing date. Due to demand and other factors it is possible your
    investment may not get accepted.
  </span>
);

export function getHistoryItemsFromOfferOrders(orders, subscriptions, offerings = []) {
  const completedSubscriptionIdsSet = new Set(subscriptions.filter(o => (o.status === 'F' || o.status === 'R' || o.status === 'C')).map(or => or.privatePlacementOrderOid));
  const completedSubscriptionIdsDict = subscriptions.filter(o => (o.status === 'F' || o.status === 'R' || o.status === 'C')).map(or => ({
    privatePlacementOrderOid: or.privatePlacementOrderOid,
    status: or.status,
  }));
  const pendingSubscriptionIdsDict = subscriptions.filter(o => (o.status === 'I' || o.status === 'O' || o.status === 'A' || o.status === 'W')).map(or => ({
    privatePlacementOrderOid: or.privatePlacementOrderOid,
    status: or.status,
    isCancellable: or.status === 'I' || or.status === 'A' || or.status === 'O',
  }));

  const completedOrders = orders.filter(o => completedSubscriptionIdsSet.has(o.folioPrivatePlacementOrderOid));
  const pendingOrders = orders.filter(o => !completedSubscriptionIdsSet.has(o.folioPrivatePlacementOrderOid));

  const getIfAnyConditionalOfferDetails = order => ({
    isConditional: order.isConditional || false,
    minSharePrice: order.minSharePrice,
    maxSharePrice: order.maxSharePrice,
  });

  const pendingOrdersResult = pendingOrders.map((order) => {
    const folioOfferId = get(order, 'offerId', '');
    const offering = offerings.find(offer => (offer.id === folioOfferId));
    const description = offering ? offering.name : '';
    const status = pendingSubscriptionIdsDict.filter(o => (o.privatePlacementOrderOid === order.folioPrivatePlacementOrderOid)).map(o => o.status)[0];
    const isCancellable = (
      (order.status === 'created') ||
      (order.status === 'submitted' && pendingSubscriptionIdsDict.filter(o => (o.privatePlacementOrderOid === order.folioPrivatePlacementOrderOid)).map(o => o.isCancellable)[0])
    );
    const isCanceled = order.status === 'canceled';
    const item = {
      key: uniqueId(),
      description,
      displayDate: Moment(get(order, 'updatedAt')).format('MMM D, YYYY'),
      date: get(order, 'updatedAt'),
      type: 'offerOrder',
      status: status === undefined ? 'I' : status,
      oid: get(order, 'id'),
      details: get(order, 'snapshot'),
      transactionType: transactionTypes.OFFER_TRANSACTION,
      ...getIfAnyConditionalOfferDetails(order),
    };
    return ({
      ...item,
      name: order.isConditional ? '(Conditional) Offer Order' : 'Offer Order',
      amount: -Number(get(order, 'requestedTotalCurrencyAmt', 0)),
      notes: PendingOrderNote,
      pending: !isCanceled,
      canceled: isCanceled,
      cancellationRestricted: !isCancellable,
    });
  });

  const completedOrdersResult = completedOrders.map((order) => {
    const folioOfferId = get(order, 'offerId', '');
    const offering = offerings.find(offer => (offer.id === folioOfferId));
    const description = offering ? offering.name : '';
    const status = completedSubscriptionIdsDict.filter(o => (o.privatePlacementOrderOid === order.folioPrivatePlacementOrderOid)).map(o => o.status)[0];
    const item = {
      key: uniqueId(),
      description: description.replace('Pending', ''),
      displayDate: Moment(get(order, 'updatedAt')).format('MMM D, YYYY'),
      date: get(order, 'updatedAt'),
      type: 'offerOrder',
      status: status === undefined ? 'F' : status,
      oid: get(order, 'id'),
      details: get(order, 'snapshot'),
      transactionType: transactionTypes.OFFER_TRANSACTION,
      ...getIfAnyConditionalOfferDetails(order),
    };
    if (status === 'R') {
      return ({
        ...item,
        name: 'Rejected Order',
        amount: Number(get(order, 'requestedTotalCurrencyAmt', 0)),
        pending: false,
        completed: true,
      });
    }
    if (status === 'C'
    || order.status === 'canceled') {
      return ({
        ...item,
        name: 'Offer Order',
        amount: Number(get(order, 'requestedTotalCurrencyAmt', 0)),
        pending: false,
        canceled: true,
        completed: false,
      });
    }
    return ({
      ...item,
      name: 'Order',
      amount: Number(get(order, 'requestedTotalCurrencyAmt', 0)),
      pending: false,
    });
  }).filter(o => o.name.indexOf('Completed Order') === -1);
  return [
    ...pendingOrdersResult,
    ...completedOrdersResult,
  ];
}

export const getTypesFromHistoryItems = (items) => {
  const newItems = [];
  items.forEach(item => (newItems.push(item.name)));
  return (newItems);
};
export const getYearsFromHistoryItems = (items) => {
  const newItems = [];
  items.forEach((item) => {
    const mmt = new Moment(item.date);
    if (mmt.isValid()) newItems.push(mmt.year());
  });
  return (newItems);
};
export const getDatesFromHistoryItems = (items) => {
  const newItems = [];
  items.forEach((item) => {
    const mmt = new Moment(item.date);
    if (mmt.isValid()) newItems.push(item.date);
  });
  return (newItems);
};
export const getHistoryCompsFromHistoryItems = (
  items,
  filterFrom,
  filterTo,
  filterItemType,
  yearOpts,
  pending,
  canceled,
  onCancel,
) => {
  const statusFilteredItems = items.filter(item => !!item.pending === pending && !!item.canceled === canceled);
  const IsPendingOrCancelled = (item, year) => (year === 'Pending' && item.pending && !item.canceled) || (year === 'Cancelled' && item.canceled && !item.pending);
  let applyYearOpts = yearOpts.filter(year => ((year === 'Pending' || year === 'Cancelled') ||
    (year >= String(Moment(filterFrom).year()) &&
    year <= String(Moment(filterTo).year()))));
  if (pending && statusFilteredItems.length === 0) applyYearOpts = [];
  if (canceled && statusFilteredItems.length === 0) applyYearOpts = [];
  return (
    applyYearOpts.map((year) => {
      const itemsForYear = statusFilteredItems.filter((item) => {
        const mmt = Moment(item.date);
        return ((filterItemType === ALL_TRNS || filterItemType === item.name)
          && (mmt.year() === year || IsPendingOrCancelled(item, year))
          && mmt.isBetween(filterFrom, filterTo, 'day', '[]'));
      });
      shownCount += itemsForYear.length;
      return (
        itemsForYear.length > 0 ?
          <div key={`grp${year}`} styleName="yearGroup">{year}
            {itemsForYear.map(item => (
              <HistoryItem
                key={item.key}
                name={item.name}
                description={item.description}
                notes={item.notes}
                amount={item.amount}
                date={item.displayDate}
                pending={item.pending}
                completed={item.completed}
                canceled={item.canceled}
                cancellationRestricted={item.cancellationRestricted}
                type={item.type}
                oid={item.oid}
                status={item.status}
                transactionType={item.transactionType}
                details={item.details}
                onCancel={onCancel}
              />
            ))}
          </div> : null
      );
    }));
};

export class UnconnectedHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterItemType: 'All Transactions',
      filterFrom: new Moment().format('YYYY-MM-DD'),
      filterTo: new Moment().format('YYYY-MM-DD'),
      yearOpts: [],
      itemTypeOpts: defTypeOpts,
      historyItems: [],
      minDate: new Moment().format('YYYY-MM-DD'),
      maxDate: new Moment().format('YYYY-MM-DD'),
      allRequestsDidFetch: false,
      unfilteredHistoryItems: [],
    };
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount = () => {
    this.fetchHistoryData();
    this.props.resetHistoryFilter();
  }

  componentWillReceiveProps = (props) => {
    const historyRawItems = [
      ...getHistoryItemsFromAccntTrns(props.accountTransactions),
      ...getHistoryItemsFromCashTrns(props.accountCashTransactions),
      ...getHistoryItemsFromOrders(props.accountOrders, props.offeringSubscriptionsByAccount, props.offeringOrdersByAccount),
      ...getHistoryItemsFromOfferOrders(props.offeringOrdersByAccount, props.offeringSubscriptionsByAccount, props.offerings),
    ];

    // Itarate through all transactions and:
    // 1. Change items named: 'Window Trade' to 'Completed Order'
    // 2. Update canceled status based on canceled offer orders from reducer
    let historyItems = historyRawItems.map((item) => {
      const { transactionType } = item;
      let { name } = item;
      // Item name transformation
      if (name === 'Window Trade') {
        name = 'Security Order';
      } else if (name === 'Buy') {
        name = 'Security Order (Buy)';
      } else if (name === 'Sell') {
        name = 'Security Order (Sell)';
      }

      const getCanceledItemStatus = () => ({
        canceled: true,
        completed: false,
        pending: false,
      });
      let itemStatus = {};

      // eslint-disable-next-line default-case
      switch (item.transactionType) {
        case transactionTypes.OFFER_TRANSACTION:
            if (find(props.canceledOfferOrders, o => o === item.oid)) itemStatus = getCanceledItemStatus();
            break;
        case transactionTypes.SECURITY_TRADE:
            if (find(props.canceledOrders, o => o === item.oid)) itemStatus = getCanceledItemStatus();
            break;
        case transactionTypes.MONEY_TRANSACTION:
            if (find(props.canceledTransfers, o => o === item.oid)) itemStatus = getCanceledItemStatus();
            break;
      }
      return {
        ...item,
        ...itemStatus,
        transactionType,
        name,
      };
    });

    historyItems.sort((a, b) => {
      if (Moment(a.date).isBefore(Moment(b.date))) return 1;
      if (Moment(b.date).isBefore(Moment(a.date))) return -1;
      if (a.amount < b.amount) return 1;
      if (b.amount < a.amount) return -1;
      if (a.description < b.description) return 1;
      if (b.description < a.description) return -1;
      return 0;
    });
    let newItemTypes = [
      ...defTypeOpts,
      ...uniq(getTypesFromHistoryItems(historyItems).sort()),
    ];
    // Filter transaction select options based on top filter
    newItemTypes = newItemTypes.filter((filterItem) => {
      if (filterItem === 'All Transactions' || props.historyFilter.selected.length === 0) return true;
      const filter = find(filterTypeOptsByTransactionTypes, type => filterItem === type.filter);
      if (filter) {
        const foundTopFilter = find(props.historyFilter.selected, type => type === filter.type);
        return foundTopFilter !== undefined;
      }
      return find(props.historyFilter.selected, type => type === transactionTypes.OTHERS) !== undefined;
    });
    // Get all dates from all document types as a single array of strings
    const newDates = getDatesFromHistoryItems(historyItems);
    const newYears = reverse(uniq(getYearsFromHistoryItems(historyItems).sort()));
    const minDate = Moment.min(newDates.map(date => (Moment(date)))).format('YYYY-MM-DD');
    const maxDate = Moment.max(newDates.map(date => (Moment(date)))).format('YYYY-MM-DD');

    const unfilteredHistoryItems = [...historyItems];
    if (props.historyFilter.selected && props.historyFilter.selected.length > 0) {
      historyItems = historyItems.filter(item =>
        find(props.historyFilter.selected, sel => sel === item.transactionType) !== undefined);
    }

    this.setState({
      ...this.state,
      filterFrom: minDate,
      filterTo: maxDate,
      itemTypeOpts: newItemTypes,
      yearOpts: newYears,
      historyItems,
      unfilteredHistoryItems,
      minDate,
      maxDate,
    });

    if (
      props.accountTransactionsIsFetching !== this.props.accountTransactionsIsFetching ||
      props.accountOrdersIsFetching !== this.props.accountOrdersIsFetching ||
      props.accountCashTransactionsIsFetching !== this.props.accountCashTransactionsIsFetching ||
      props.offeringOrdersByAccountIsFetching !== this.props.offeringOrdersByAccountIsFetching ||
      props.offeringSubscriptionsByAccountIsFetching !== this.props.offeringSubscriptionsByAccountIsFetching ||
      props.offeringsIsFetching !== this.props.offeringsIsFetching
    ) {
      this.setState({
        allRequestsDidFetch: !(
          props.accountTransactionsIsFetching ||
          props.accountOrdersIsFetching ||
          props.accountCashTransactionsIsFetching ||
          props.offeringOrdersByAccountIsFetching ||
          props.offeringSubscriptionsByAccountIsFetching ||
          props.offeringsIsFetching
        ),
      });
    }
  }

  componentWillUnmount() {
    this.props.resetHistoryFilter();
  }

  async onCancel(oid, transactionType, amount) {
    let req = null;
    let transferType = null;
    const { accountNumber } = this.props;
    switch (transactionType) {
      case transactionTypes.OFFER_TRANSACTION:
        req = () => this.props.cancelOfferOrder(accountNumber, oid, transactionTypes.OFFER_TRANSACTION);
        break;
      case transactionTypes.SECURITY_TRADE:
        req = () => this.props.cancelOrder(oid, transactionTypes.SECURITY_TRADE);
        break;
      case transactionTypes.MONEY_TRANSACTION: {
        transferType = amount < 0 ? 'withdrawal' : 'deposit';
        req = () => this.props.cancelTransfer(accountNumber, oid, transferType);
        break;
      }
      default:
        break;
    }
    try {
      await req();
    } catch (err) {
      this.props.addNotification(err.toString());
    }
  }

  fetchHistoryData() {
    this.props.fetchAccountOrders(this.props.accountNumber);
    this.props.fetchAccountTransactions(this.props.accountNumber, '5y', true);
    this.props.fetchAccountCashTransactions(this.props.accountNumber, '5y', true);
    this.props.fetchOfferingSubscriptions(this.props.accountNumber);
    this.props.fetchOfferingOrders(this.props.accountNumber);
    this.props.fetchOfferings();
  }

  filterItemType = (event) => {
    this.setState({
      ...this.state,
      filterItemType: event.target.value,
    });
  }

  filterFrom = (value) => {
    const momentValue = Moment(value);
    if (momentValue.isAfter(this.state.filterTo)) {
      this.setState({
        ...this.state,
        filterTo: Moment(value).format('YYYY-MM-DD'),
        filterFrom: Moment(value).format('YYYY-MM-DD'),
      });
    } else {
      this.setState({
        ...this.state,
        filterFrom: Moment(value).format('YYYY-MM-DD'),
      });
    }
  }

  filterTo = (value) => {
    const momentValue = Moment(value);
    if (momentValue.isBefore(this.state.filterFrom)) {
      this.setState({
        ...this.state,
        filterTo: Moment(value).format('YYYY-MM-DD'),
        filterFrom: Moment(value).format('YYYY-MM-DD'),
      });
    } else {
      this.setState({
        ...this.state,
        filterTo: Moment(value).format('YYYY-MM-DD'),
      });
    }
  }

  render() {
    const {
      historyItems,
      filterFrom,
      filterTo,
      filterItemType,
      yearOpts,
    } = this.state;
    const propsToPass = {
      itemTypeOpts: this.state.itemTypeOpts,
      itemTypeSelected: this.state.filterItemType,
      onItemTypeChange: this.filterItemType,
      dateMin: this.state.minDate,
      fromSelected: this.state.filterFrom,
      onFromChange: this.filterFrom,
      dateMax: this.state.maxDate,
      toSelected: this.state.filterTo,
      onToChange: this.filterTo,
      mediaQueryValues: this.props.mediaQueryValues,
      LoadingComponent: () => (
        <div>
          {
            !this.state.allRequestsDidFetch ?
              <div styleName="loading">
                <img
                  src={loadGif}
                  alt="Loading"
                />
              </div> : null
          }
        </div>
      ),
      isLoading: !this.state.allRequestsDidFetch,
    };
    shownCount = 0;
    const pendingItems = getHistoryCompsFromHistoryItems(
      historyItems,
      filterFrom,
      filterTo,
      filterItemType,
      ['Pending'],
      true,
      false,
      this.onCancel,
    );
    const completedItems = getHistoryCompsFromHistoryItems(
      historyItems,
      filterFrom,
      filterTo,
      filterItemType,
      yearOpts,
      false,
      false,
      this.onCancel,
    );
    const canceledItems = getHistoryCompsFromHistoryItems(
      historyItems,
      filterFrom,
      filterTo,
      filterItemType,
      ['Cancelled'],
      false,
      true,
      this.onCancel,
    );
    const filterCategoryLengths = {};
    // eslint-disable-next-line no-return-assign
    values(transactionTypes).forEach(item => (filterCategoryLengths[item] = 0));
    // eslint-disable-next-line no-return-assign
    this.state.unfilteredHistoryItems.forEach(key => (filterCategoryLengths[key.transactionType] += 1));
    return (
      <div>
        <History {...propsToPass}>
          <HistoryTopFilter filterCategoryLengths={filterCategoryLengths} />
          <HistoryTopFilterTitle />
          {historyItems && historyItems.length > 0
          && shownCount < historyItems.length ?
            <div styleName="countMessage">
              Showing {formatQuantity(shownCount)}
              &nbsp;of {formatQuantity(historyItems.length)} transactions
            </div>
            : null}
          {pendingItems}
          {historyItems && historyItems.length > 0 ?
          completedItems
          : <div styleName="histMessage">No transactions to display</div>}
          {
            canceledItems && canceledItems.length ? canceledItems : null
          }
        </History>
      </div>
    );
  }
}

UnconnectedHistoryContainer.propTypes = {
  mediaQueryValues: PropTypes.shape({}),
};

UnconnectedHistoryContainer.defaultProps = {
  mediaQueryValues: {},
};

const mapStateToProps = state => ({
  accountNumber: get(state, 'currentAccount'),
  accountTransactions: get(state, `accountTransactionsByAccount[${get(state, 'currentAccount')}].data`, []),
  accountTransactionsIsFetching: get(state, `accountTransactionsByAccount[${get(state, 'currentAccount')}].isFetching`),
  accountOrders: get(state, `accountOrdersByAccount[${get(state, 'currentAccount')}].data`, []),
  accountOrdersIsFetching: get(state, `accountOrdersByAccount[${get(state, 'currentAccount')}].isFetching`),
  accountCashTransactions: get(state, `accountCashTransactionsByAccount[${get(state, 'currentAccount')}].data`, []),
  accountCashTransactionsIsFetching: get(state, `accountCashTransactionsByAccount[${get(state, 'currentAccount')}].isFetching`),
  offeringOrdersByAccount: get(state, `offeringOrdersByAccount[${get(state, 'currentAccount')}].data`, []),
  offeringOrdersByAccountIsFetching: get(state, `offeringOrdersByAccount[${get(state, 'currentAccount')}].isFetching`),
  offerings: get(state, 'offerings.data', []),
  offeringsIsFetching: get(state, 'offerings.isFetching'),
  offeringSubscriptionsByAccount: get(state, `offeringSubscriptionsByAccount[${get(state, 'currentAccount')}].data`, []),
  offeringSubscriptionsByAccountIsFetching: get(state, `offeringSubscriptionsByAccount[${get(state, 'currentAccount')}].isFetching`),
  historyFilter: get(state, 'historyFilter'),
  cancelations: get(state, 'cancelations'),
  canceledOrders: get(state, 'cancelations.canceledOrders'),
  canceledOfferOrders: get(state, 'cancelations.canceledOfferOrders'),
  canceledTransfers: get(state, 'cancelations.canceledTransfers'),
});

const mapDispatchToProps = {
  fetchAccountTransactions,
  fetchAccountOrders,
  fetchOfferingOrders,
  fetchAccountCashTransactions,
  fetchOfferingSubscriptions,
  fetchOfferings,
  resetHistoryFilter,
  cancelTransfer,
  cancelOfferOrder,
  cancelOrder,
  addNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedHistoryContainer);



// WEBPACK FOOTER //
// ./src/components/History/index.js